 
 <input type="text" spellcheck="false"   class="form-control m-3" #answerInput name="answerInput" autofocus
 [placeholder]="language.typeInYourAnswer" *ngIf="issaq" required (change)="onAnswerChange()" 
 (input)="onAnswerInputChange()" (focus)="onInputFocus()"
       (click)="onInputClick()" (keydown)="preventPipe($event)" 
 [attr.aria-label]="language.typeInYourAnswer" [attr.aria-readonly]="answerInput.readOnly ? 'true' : null"/>

 <div class="alert alert-danger m-3" *ngIf="issaq && !isInputAllowed" role="alert">
  {{language.quillEditorEssayReadOnlyMessage}}
</div>